import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import { useAxios } from "../customHooks";
import { useAuth } from "./Auth-Context";
import { useVideo } from "./Video-Context";

const LikeWatchLaterContext = createContext();

const LikeWatchLaterProvider = ({ children }) => {
  const navigate = useNavigate();
  const { encodedToken, user , responseUpdateUserProfile} = useAuth();
  const { deleteVideoFromDBResponse } = useVideo()
  const {
    response: likeResponse,
    isLoading: likeApiCallLoading,
    operation: likeOperation,
  } = useAxios();
  const {
    response: watchLaterResponse,
    isLoading: watchLaterApiCallLoading,
    operation: watchLaterOperation,
  } = useAxios();
  const [likedList, setLikedList] = useState([]);
  const [watchLaterList, setWatchLaterList] = useState([]);

  const handleLike = (videoId) => {
    if (encodedToken === null) navigate("/login", { replace: true });
    likeOperation({
      method: "patch",
      url: `${process.env.REACT_APP_BACKEND_API}likes/v/${videoId}`,
      headers: { authorization: encodedToken },
    });
  };

  const addToWatchLater = (videoId) => {
    if (encodedToken === null) navigate("/login", { replace: true });
    watchLaterOperation({
      method: "patch",
      url: `${process.env.REACT_APP_BACKEND_API}watchlaters/v/${videoId}`,
      headers: { authorization: encodedToken },
    });
  };

  useEffect(() => {
    if (user && encodedToken) {
      watchLaterOperation({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}watchlaters/u/${user._id}`,
        headers: { authorization: encodedToken },
      });
    }
  }, [user?._id, encodedToken]);

  useEffect(() => {
    if (user && encodedToken) {
      likeOperation({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}likes/u/${user._id}`,
        headers: { authorization: encodedToken },
      });
    }
  }, [user?._id, encodedToken]);

  useEffect(() => {
  if(responseUpdateUserProfile != null){
    watchLaterOperation({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}watchlaters/u/${user._id}`,
      headers: { authorization: encodedToken },
    });
    likeOperation({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}likes/u/${user._id}`,
      headers: { authorization: encodedToken },
    });
  }
  },[responseUpdateUserProfile])

  useEffect(() => {
   if(deleteVideoFromDBResponse != null && user && encodedToken){
    watchLaterOperation({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}watchlaters/u/${user._id}`,
      headers: { authorization: encodedToken },
    });
    likeOperation({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}likes/u/${user._id}`,
      headers: { authorization: encodedToken },
    });
   }
  },[deleteVideoFromDBResponse])

  useEffect(() => {
    if (likeResponse !== undefined) {
      setLikedList(likeResponse.data);
    }
  }, [likeResponse]);

  useEffect(() => {
    if (watchLaterResponse !== undefined) {
      setWatchLaterList(watchLaterResponse.data);
    }
  }, [watchLaterResponse]);

  const memoizedContextValue = useMemo(
    () => ({
      handleLike,
      likedList,
      likeApiCallLoading,
      watchLaterApiCallLoading,
      addToWatchLater,
      watchLaterList,
    }),
    [
      handleLike,
      likedList,
      likeApiCallLoading,
      watchLaterApiCallLoading,
      addToWatchLater,
      watchLaterList,
    ]
  );
  return (
    <LikeWatchLaterContext.Provider value={memoizedContextValue}>
      {children}
    </LikeWatchLaterContext.Provider>
  );
};

const useLikeWatchLater = () => useContext(LikeWatchLaterContext);

export { LikeWatchLaterProvider, useLikeWatchLater };
